<template>
  <div>
    <h2 v-if="module">{{ module.ModuleName }}</h2>
    <div class="row">
      <div class="col-md-6">
        <h5>{{ $t("title.unselectedstore") }}</h5>
        <div class="card card-table">
          <div class="card-header">
            <button
              type="button"
              class="btn btn-outline-primary py-2 px-4"
              style="border-color: transparent"
              @click="onAdd"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>

          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="allAdd"
                        v-model="allAdd"
                      />
                      <label class="custom-control-label" for="allAdd">{{
                        $t("columnName.add")
                      }}</label>
                    </div>
                  </th>
                  <th>{{ $t("columnName.storenumber") }}</th>
                  <th>{{ $t("columnName.storename") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="notSelected in notSelecteds"
                  :key="notSelected.StoreId"
                  @click="notSelectedClick(notSelected.StoreId)"
                >
                  <td>
                    <input
                      class="checkbox"
                      type="checkbox"
                      :value="notSelected.StoreId"
                      v-model="addIds"
                    />
                  </td>
                  <td>{{ notSelected.StoreNumber }}</td>
                  <td>{{ notSelected.StoreName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <h5>{{ $t("title.selectedstore") }}</h5>
        <div class="card card-table">
          <div class="card-header">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon py-2 px-4"
              @click="onRemove"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="allRemove"
                        v-model="allRemove"
                      />
                      <label class="custom-control-label" for="allRemove">{{
                        $t("columnName.remove")
                      }}</label>
                    </div>
                  </th>
                  <th>{{ $t("columnName.storenumber") }}</th>
                  <th>{{ $t("columnName.storename") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="selected in selecteds"
                  :key="selected.StoreId"
                  @click="selectedClick(selected.StoreId)"
                >
                  <td>
                    <input
                      class="checkbox"
                      type="checkbox"
                      :value="selected.StoreId"
                      v-model="removeIds"
                    />
                  </td>
                  <td>{{ selected.StoreNumber }}</td>
                  <td>{{ selected.StoreName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: {},
      notSelecteds: [],
      selecteds: [],
      addIds: [],
      removeIds: [],
      allAdd: false,
      allRemove: false,
    };
  },
  watch: {
    allAdd(value) {
      this.addIds = [];
      if (value) {
        this.notSelecteds.forEach((item) => this.addIds.push(item.StoreId));
      }
    },
    allRemove(value) {
      this.removeIds = [];
      if (value) {
        this.selecteds.forEach((item) => this.removeIds.push(item.StoreId));
      }
    },
  },
  methods: {
    notSelectedClick(id) {
      const index = this.addIds.indexOf(id);
      if (index >= 0) {
        this.addIds.splice(index, 1);
      } else {
        this.addIds.push(id);
      }
    },
    selectedClick(id) {
      const index = this.removeIds.indexOf(id);
      if (index >= 0) {
        this.removeIds.splice(index, 1);
      } else {
        this.removeIds.push(id);
      }
    },
    updateStores() {
      const vm = this;
      this.$api.modules.getStores(vm.module.ModuleId).then((data) => {
        vm.addIds = [];
        vm.removeIds = [];
        vm.notSelecteds = data.NotSelecteds;
        vm.selecteds = data.Selecteds;
        vm.allAdd = false;
        vm.allRemove = false;
      });
    },
    onAdd() {
      if (this.addIds.length == 0) {
        this.$func.message.alert("請選擇門市 !");
        return;
      }
      const vm = this;
      this.$api.modules
        .postStores({
          ModuleId: vm.module.ModuleId,
          StoreIds: vm.addIds,
        })
        .then(() => vm.updateStores());
    },
    onRemove() {
      if (this.removeIds.length == 0) {
        this.$func.message.alert("請選擇門市 !");
        return;
      }
      const vm = this;
      this.$api.modules
        .deleteStores({
          ModuleId: vm.module.ModuleId,
          StoreIds: vm.removeIds,
        })
        .then(() => vm.updateStores());
    },
  },
  created() {
    const vm = this;
    this.$api.modules.get(this.$route.params["id"]).then((data) => {
      if (!data) {
        vm.$func.message.alert("查無此模組 !");
        vm.$router.go(-1);
      }
      vm.module = data;
      vm.updateStores();
    });
  },
};
</script>
